module.exports = __webpack_public_path__ + "img/puberty-decal-12.6759240d.png";